export const selectedCountry = {
  placeholder: "اختر دولة",
};
